import security from "common/managers/security";

export default {
    /**
     * Apply header to anything that looks like an XMLHttpRequest.
     * Does NOT check state.
     * @param xhr request
     * @private
     */
    _apply: function(xhr) {
        var token = security.getCSRFToken();
        if(token) {
            xhr.setRequestHeader("X-XSRF-TOKEN", token);
        }

        var auth_token = security.getAuthToken();
        if(auth_token) {
            xhr.setRequestHeader("Authorization", "Bearer " + auth_token);
        }

        var audit_user = security.getAuditUser();
        if(audit_user && audit_user.length > 0) {
            xhr.setRequestHeader("X-AUDITUSER", audit_user);
        }

        if(security.isRestrictedToGateway()) {
            xhr.setRequestHeader("X-GATEWAY_PROXY_REQUEST", "UI");
        }
    },

    /**
     * Apply the CSRF Token to all jquery ajax calls.
     * @param $ jquery
     */
    applyCSRF: function($) {
        $.ajaxPrefilter((options, originalOptions, jqXHR) => {
            if(options?.xhrFields?.withCredentials !== false) {
                this._apply(jqXHR)
            }
        });
    }
}
